export const formatDate = (value: string) => {
  return value
    .replace(/\D+/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\/\d{2})(\d)/, '$1/$2')
    .replace(/(\/\d{4})\d+?$/, '$1');
};

export const formatCPF = (value: string) => {
  return value
    .replace(/\D+/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
};

export const formatPhone = (value: string) => {
  return value
    .replace(/\D+/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3')
    .replace(/(-\d{4})\d+?$/, '$1');
};

export const formatCep = (value: string) => {
  return value
    .replace(/\D+/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1');
};

export const stripTaxpayerId = (value: string): string =>
  value.replace(/[./\s-]/g, '').toUpperCase();

export const ALPHANUMERIC_CNPJ_REGEX = /^[A-Z0-9]{12}[0-9]{2}$/;

export const isAlphanumericCnpjBase = (value: string): boolean =>
  /[A-Z]/.test(stripTaxpayerId(value).slice(0, 12));

export const stripAndFormatCnpj = (value: string): string =>
  stripTaxpayerId(formatCNPJ(value));

export const normalizeTaxpayerSearchValue = (
  parameterName?: string,
  value?: string,
): string | undefined => {
  if (!value) return value;
  const isTaxpayerIdParam =
    parameterName === 'taxpayer_id' || parameterName === 'taxpayerId';
  return isTaxpayerIdParam ? stripTaxpayerId(value) : value;
};

export const formatCNPJ = (value: string) => {
  const v = value
    .replace(/[^A-Z0-9]/gi, '')
    .toUpperCase()
    .slice(0, 14);
  if (v.length <= 2) return v;
  if (v.length <= 5) return `${v.slice(0, 2)}.${v.slice(2)}`;
  if (v.length <= 8) return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5)}`;
  if (v.length <= 12)
    return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8)}`;
  return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(
    8,
    12,
  )}-${v.slice(12)}`;
};

export const formatBankAccount = (value: string) => {
  return value
    .replace(/\D+/g, '')
    .replace(/(\d{7})(\d)/, '$1-$2')
    .replace(/(-\d{1})\d+?$/, '$1');
};

export const formatDecimalField = (value: string) => {
  return value.replace(/[^\d,]+/g, '');
};
